import React, { useEffect, useState } from 'react';
import { message } from 'antd';
import { useHeaderChanger } from 'hooks/useHeaderChanger';
import { PageFormBox } from 'ui/PageFormBox';
import { IntegrationService } from 'services/IntegrationService';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { FIREBASE_INTEGRATION } from 'constants/integration';
import { FETCHING_STATUS, REQUEST_LOADING } from 'constants/alerts';
import { IntegrationForm } from '../IntegrationForm';

function Firebase() {
  useDocumentTitle('Настройки интеграции с Firebase');
  useHeaderChanger('Настройки интеграции с Firebase');
  const [config, setConfig] = useState(null);

  useEffect(() => {
    fetchFirebaseConfig();
  }, []);

  const fetchFirebaseConfig = async () => {
    const hide = message.loading(FETCHING_STATUS);

    try {
      const { items } = await IntegrationService.getConfig(
        FIREBASE_INTEGRATION
      );
      setConfig({
        login: items?.global_fbs?.login,
        password: items?.global_fbs?.pwd,
        integration: items?.fbs_conf?.firebase_enable,
        url: items?.fbs_conf?.firebase_send_url,
      });
    } catch (err) {
      message.error('Не удалось загрузить конфиг');
    } finally {
      hide();
    }
  };

  const handleSubmit = async ({ login, password, url, integration }) => {
    const hide = message.loading(REQUEST_LOADING);
    const payload = {
      global_fbs: {
        login,
        pwd: password,
      },
      fbs_conf: {
        firebase_enable: integration,
        firebase_send_url: url,
      },
    };

    try {
      const isSuccess = await IntegrationService.saveConfig(
        FIREBASE_INTEGRATION,
        payload
      );

      if (isSuccess) {
        message.success('Успешно сохранено');
      }
    } catch (err) {
      message.error('Не удалось сохранить данные');
    } finally {
      hide();
    }
  };

  return (
    <PageFormBox>
      <IntegrationForm
        pageId="IntegrationConfig"
        config={config}
        formTitle="Глобальные настройки для интеграции с Firebase"
        onSubmit={handleSubmit}
      />
    </PageFormBox>
  );
}

export { Firebase };
